module.exports = __webpack_public_path__ + "img/iOS-select@3x.c643679f.png";